export default "__VITE_ASSET__CN$YwFvR__"